import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'

function PanelAutorizacionEtiquetas(props) {
    return (
        <Fragment><br/>
            <div className='container'>
            <h1>Panel Autorizacion Etiquetas</h1>
            
            </div>



        </Fragment>
    );
};


export default withRouter(PanelAutorizacionEtiquetas)
